/* Load a product's GLB only when its selected gallery slide is visible. */
if (!customElements.get('woodlas-model')) {
  let libraryPromise;
  const loadLibrary = (url) => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (libraryPromise) return libraryPromise;
    libraryPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module'; script.src = url; script.dataset.woodlasModel = '';
      script.onload = () => customElements.whenDefined('model-viewer').then(resolve);
      script.onerror = () => { script.remove(); libraryPromise = null; reject(new Error('Model library unavailable')); };
      document.head.append(script);
    });
    return libraryPromise;
  };
  customElements.define('woodlas-model', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slide = this.closest('[data-media-id]'); this.model = this.querySelector('model-viewer');
      if (!this.slide || !this.model) return;
      this.controller = new AbortController();
      this.status = this.querySelector('[data-model-status]');
      this.tools = this.querySelector('[data-model-ready-tools]');
      this.retry = this.querySelector('[data-model-retry]');
      this.rotate = this.querySelector('[data-model-rotate]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (target, type, fn) => target?.addEventListener(type, fn, {signal:this.controller.signal});
      on(this.model, 'load', () => { this.dataset.modelState = 'loaded'; this.status.textContent = ''; this.tools.hidden = false; this.retry.hidden = true; this.sync(); });
      on(this.model, 'error', () => this.fail());
      on(this.querySelector('[data-model-reset]'), 'click', () => { this.wantsRotation = false; this.model.setAttribute('camera-orbit', this.dataset.orbit); this.model.setAttribute('field-of-view', 'auto'); this.sync(); });
      on(this.rotate, 'click', () => { this.wantsRotation = !this.wantsRotation; this.sync(); });
      on(this.retry, 'click', () => { this.model.removeAttribute('src'); this.dataset.modelState = 'idle'; this.sync(); });
      on(document, 'visibilitychange', () => this.sync());
      on(this.motion, 'change', () => this.sync());
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.slide, {attributes:true,attributeFilter:['class']});
      this.visibility = new IntersectionObserver((entries) => { this.inView = entries[0].isIntersecting; this.sync(); }, {threshold:0.01});
      this.visibility.observe(this); this.sync();
    }
    async activate() {
      if (this.dataset.modelState !== 'idle') return;
      this.dataset.modelState = 'loading'; this.status.textContent = 'Loading 3D preview…'; this.retry.hidden = true;
      const controller = this.controller;
      try {
        await loadLibrary(this.dataset.library);
        if (!this.isConnected || this.controller !== controller) return;
        this.model.src = this.model.dataset.src;
      } catch (_) { if (this.controller === controller) this.fail(); }
    }
    fail() { this.dataset.modelState = 'error'; this.status.textContent = '3D could not load. Product photos are still available.'; this.retry.hidden = false; this.tools.hidden = true; this.sync(); }
    sync() {
      const visible = this.inView && this.slide.classList.contains('is-active') && document.visibilityState === 'visible';
      if (visible) this.activate();
      this.rotate.disabled = this.motion.matches || this.dataset.modelState !== 'loaded';
      this.rotate.setAttribute('aria-pressed', String(!!this.wantsRotation && !this.motion.matches));
      this.rotate.textContent = this.wantsRotation && !this.motion.matches ? 'Pause rotation' : 'Auto rotate';
      this.model.toggleAttribute('auto-rotate', !!this.wantsRotation && visible && !this.motion.matches && this.dataset.modelState === 'loaded');
    }
    disconnectedCallback() { this.observer?.disconnect(); this.visibility?.disconnect(); this.controller?.abort(); this.controller = null; this.model?.removeAttribute('auto-rotate'); if (this.dataset.modelState === 'loading') this.dataset.modelState = 'idle'; }
  });
}
